export default __webpack_public_path__ + "static/media/excel.cbecff83.png";